<template>
    <div class="dialog"  style="width: 30%" v-show="show">
        <span class="title">{{title}}</span>
        <el-table :data="tableData">
            <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
            <el-table-column v-for="(item,index) in dialogColumn" :key='index' :property="item.value" :label="item.label" align="center" width="auto"></el-table-column>
        </el-table>
<!-- 
		<FloatDiv :tableData="tableData" title="房间信息" :dialogColumn='dialogColumn' :show='dialogTableVisible' />
        dialogTableVisible: true,
        dialogColumn: [
            { label: '单价名称', value: 'priceName'},
            { label: '单价', value: 'price'},
            { label: '生效日期', value: 'startDate'},
        ], -->
    </div>
</template>

<script>
export default {
    props: {
        tableData: Array,
        dialogColumn: Array,
        title: String,
        show: Boolean
    },
    data() {
        return {
        }
    }
}
</script>

<style scoped>
.dialog {
	position: absolute;
    top: 10%;
    left: 180px;
	padding: 10px;
	background: white;
    z-index: 3000;
    box-shadow: 2px 0 8px gray;
}
.dialog .title {
	font-size: 18px;
	font-weight: 600;
}
</style>